import { render, staticRenderFns } from "./body.vue?vue&type=template&id=d2b6433e&scoped=true"
import script from "./body.vue?vue&type=script&lang=js"
export * from "./body.vue?vue&type=script&lang=js"
import style0 from "./body.vue?vue&type=style&index=0&id=d2b6433e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b6433e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2b6433e')) {
      api.createRecord('d2b6433e', component.options)
    } else {
      api.reload('d2b6433e', component.options)
    }
    module.hot.accept("./body.vue?vue&type=template&id=d2b6433e&scoped=true", function () {
      api.rerender('d2b6433e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workBench/components/body.vue"
export default component.exports